// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__bLzm0","controls":"styles_controls__10m6a","charLimit":"styles_charLimit__3rWYf","input":"styles_input__31CwB","send":"styles_send__CVS0X"};